export function postcardDate(value) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || "")) return "";
  const [y, m, d] = value.split("-").map(Number);
  const date = new Date(y, m - 1, d);
  if (date.getFullYear() !== y || date.getMonth() !== m - 1 || date.getDate() !== d) return "";
  return date.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

// Only a plain public login URL is printable: no tokens, redirects, or check-in routes.
export function postcardDestination(value) {
  try {
    const url = new URL(value);
    const host = url.hostname.toLowerCase();
    const development = /(^|\.)(localhost|local|test|invalid)$/.test(host)
      || /(^|\.)(replit\.dev|repl\.co|replit\.internal)$/.test(host)
      || /preview|staging|development/.test(host);
    const ipOrPrivate = /^[\d.]+$/.test(host) || host.includes(":")
      || !host.includes(".") || host.endsWith(".internal") || host.endsWith(".lan");
    if (development) return { error: "Development / preview destination — not for mailing. Enter the published client portal login URL." };
    if (url.protocol !== "https:" || ipOrPrivate || url.port || url.username || url.password
      || url.search || url.hash || url.pathname !== "/portal/login") {
      return { error: "Use a public HTTPS URL ending in /portal/login, with no port, query, token, or fragment." };
    }
    return { url: url.href };
  } catch {
    return { error: "Enter a usable public client portal login URL." };
  }
}

export function postcardWarnings(year, period, destination) {
  const warnings = [];
  if (!period || period.year !== year) warnings.push("Selected-year program settings are missing.");
  if (!postcardDate(period?.open_date)) warnings.push("Signup opening date is missing or invalid.");
  if (!postcardDate(period?.close_date)) warnings.push("Signup deadline is missing or invalid.");
  if (postcardDate(period?.open_date) && postcardDate(period?.close_date) && period.open_date > period.close_date) {
    warnings.push("Signup deadline must not precede the opening date.");
  }
  const phone = period?.mailer_contact_phone?.trim() || "";
  if (!phone) warnings.push("Selected-year help phone is missing.");
  else if (phone.length > 45 || phone.replace(/\D/g, "").length < 7) warnings.push("Help phone is invalid or too long for the postcard.");
  const target = postcardDestination(destination);
  if (target.error) warnings.push(target.error);
  else if (target.url.length > 110) warnings.push("Portal URL is too long for a legible postcard. Use a shorter published login address.");
  return warnings;
}